(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./swiper-item.less", "../_mixins/relation"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./swiper-item.less"), require("../_mixins/relation"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.swiperItem, global.relation);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _swiperItem, _relation) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        ref: "swiperItem",
        staticClass: "nx-swiper-item",
        class: _vm.isRound ? 'nx-swiper-round' : '',
        style: {
          width: _vm.swiperWidth,
          height: _vm.swiperHeight
        },
        attrs: {
          "aria-label": _vm.ariaAttrsInside.ariaLabel,
          "tabindex": _vm.ariaAttrsInside.ariaLabel ? -1 : undefined
        }
      }, [_vm._t("default")], 2);
    },
    name: 'nx-swiper-item',
    mixins: [(0, _relation.ChildrenMixin)('nxSwiper')],
    props: {
      width: {
        type: [Number, String]
      },
      onClickEvent: {
        type: Function
      },
      ariaAttrs: {
        type: Object,
        default: function _default() {
          return {
            bannerPreTalkStatus: true,
            bannerContent: '',
            clickStatus: true,
            unAriaSite: false
          };
        }
      }
    },
    computed: {
      swiperWidth: function swiperWidth() {
        if (this.width) return this.width;
        if (this.parent.isCardSlide) return 'auto';
        return !this.parent.isVertical ? "".concat(this.parent.dimension, "px") : 'auto';
      },
      swiperHeight: function swiperHeight() {
        if (this.height) return this.height;
        if (this.parent.tabSlideMode === 'halfPage') return '';
        return this.parent.isVertical ? "".concat(this.parent.dimension, "px") : 'auto';
      },
      isRound: function isRound() {
        return this.parent.round || false;
      },
      ariaAttrsInside: function ariaAttrsInside() {
        var _this$ariaAttrs = this.ariaAttrs,
            _this$ariaAttrs$speak = _this$ariaAttrs.speakBannerNumber,
            speakBannerNumber = _this$ariaAttrs$speak === void 0 ? false : _this$ariaAttrs$speak,
            _this$ariaAttrs$banne = _this$ariaAttrs.bannerPreTalkStatus,
            bannerPreTalkStatus = _this$ariaAttrs$banne === void 0 ? true : _this$ariaAttrs$banne,
            _this$ariaAttrs$banne2 = _this$ariaAttrs.bannerContent,
            bannerContent = _this$ariaAttrs$banne2 === void 0 ? '' : _this$ariaAttrs$banne2,
            _this$ariaAttrs$click = _this$ariaAttrs.clickStatus,
            clickStatus = _this$ariaAttrs$click === void 0 ? true : _this$ariaAttrs$click,
            _this$ariaAttrs$unAri = _this$ariaAttrs.unAriaSite,
            unAriaSite = _this$ariaAttrs$unAri === void 0 ? false : _this$ariaAttrs$unAri;
        var ariaLabel = "".concat(bannerContent, "-") + (speakBannerNumber ? "\u7B2C".concat(this.parent.realIndex + 1, "\u9875-\u5171").concat(this.parent.oItemCount, "\u9875") : '');

        if (!bannerContent) {
          return {
            ariaLabel: ''
          };
        }

        ariaLabel = (bannerPreTalkStatus ? '广告图片-' : '') + ariaLabel;
        ariaLabel += clickStatus ? '-点按两次即可激活' : '';
        ariaLabel += unAriaSite ? '-无障碍适配不完整' : '';

        if (this.parent.oItemCount > 1 && this.parent.dragable) {
          ariaLabel += this.parent.isVertical ? '-可上下滑动切换' : '-可左右滑动切换';
        }

        return {
          ariaLabel: ariaLabel
        };
      }
    },
    mounted: function mounted() {
      return this.parent && this.parent.swiperItemCreated(this);
    },
    destroyed: function destroyed() {
      return this.parent && this.parent.swiperItemDestroyed(this);
    }
  };
  _exports.default = _default2;
});